class QuickViewDrawer extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('close', () => {
        const drawerContent = this.querySelector('.quick-view__content');
        if (drawerContent) {
          drawerContent.innerHTML = '';
          drawerContent.classList.remove('hide-cover');
        }

        document.dispatchEvent(new CustomEvent('quickview:close'));
      });
    }
  }
  if (!customElements.get('quick-view-drawer')) customElements.define('quick-view-drawer', QuickViewDrawer);
  
  class QuickViewButton extends HTMLElement {
    constructor() {
      super();
  
      this.addEventListener('click', (event) => {
        if (event.target.closest('.card-quick-view')) event.preventDefault()
        this.closest('body')?.classList.add('hidden', 'quick-view-open')
        const wrapper = this.closest('.card-container') || this.closest('.image-with-hotspots__hotspot');
        const drawer = wrapper?.querySelector('quick-view-drawer');
        if (drawer) {
          const quickView = drawer.querySelector('quick-view');
          if (quickView) quickView.opener = this.querySelector('button, a, [tabindex]') || document.activeElement;
          drawer.querySelector('summary').click();
          drawer.querySelector('quick-view')?.loadProduct();
          document.dispatchEvent(new CustomEvent('quickview:open', {
            detail: {
              productUrl: this.dataset.productUrl
            }
          }));
        }
        else if (this.dataset.productUrl) {
          window.location = this.dataset.productUrl;
        }
      });
      this.quickButton = this.querySelector('.quick') || this.closest('.quick')
      if(this.quickButton?.closest('.card__extras')) {
        this.quickButton.addEventListener('focus', () => {
          this.quickButton.closest('.card__extras').style.bottom = '8px'
        })
        this.quickButton.addEventListener('blur', () => {
          this.quickButton.closest('.card__extras').style.bottom = '-54px'
        })
        this.quickButton.addEventListener('quickview:open', () => {
          this.quickButton.closest('.card__extras').style.bottom = '-54px'
        })
      }
    }
  }
  if (!customElements.get('quick-view-button')) customElements.define('quick-view-button', QuickViewButton);
  
  class QuickView extends HTMLElement {
    constructor() {
      super();
      this.overlay = this.querySelector('.overlay')
      this.quickModal = this.querySelector('.popup-wrapper')
      this.closeButton = this.querySelector('.button-close')
      this.addEventListener('click', (event) => {
        if (event.target.closest('.overlay') || event.target.closest('.button-close')) this.closeQuickView()
      })
      document.addEventListener('keyup', (event) => {
        if (event.code && event.code.toUpperCase() === 'ESCAPE' && this.querySelector('.popup-wrapper.open')) this.closeQuickView()
      })
    }
  
    connectedCallback() {
      new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
    }
  
    handleIntersection(entries, _observer) {
      if (!entries[0].isIntersecting) return;
      this.loadProduct();
    }

    loadProduct() {
      const selector = '.quick-view__content';
      const drawerContent = this.querySelector(selector);
      this.productUrl = this.dataset.productUrl
      if (!drawerContent || !this.productUrl) return;
      if (drawerContent.children.length > 0) return;
      if (this.loadingPromise) return this.loadingPromise;

      const separator = this.productUrl.includes('?') ? '&' : '?';
      this.sectionUrl = `${this.productUrl}${separator}view=quick-view`;
      const version = this.loadVersion || 0;

      this.loadingPromise = fetch(this.sectionUrl)
        .then(response => {
          if (!response.ok) throw new Error(`Quick view request failed: ${response.status}`);
          return response.text();
        })
        .then(responseText => {
          if (version !== (this.loadVersion || 0)) return;
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          const productElement = responseHTML.querySelector(selector);
          if (!productElement) throw new Error('Quick view content was not found in the response.');

          this.setInnerHTML(drawerContent, productElement.innerHTML);

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          document.body.classList.add('quick-view-load')
          drawerContent.classList.add('hide-cover');
          drawerContent.setAttribute('aria-label', productElement.getAttribute('aria-label') || this.opener?.textContent.trim() || 'Quick View');
          if (this.closest('details')?.open) {
            const popup = this.querySelector('.popup-wrapper');
            if (popup) trapFocus(popup, popup.querySelector('.button-close') || drawerContent);
          }

          document.dispatchEvent(new CustomEvent('quickview:loaded', {
            detail: {
              productUrl: this.dataset.productUrl
            }
          }));
        })
        .catch(e => {
          console.error(e);
        })
        .finally(() => {
          if (version === (this.loadVersion || 0)) this.loadingPromise = null;
        });

      return this.loadingPromise;
    }
  
    setInnerHTML(element, html) {
      element.innerHTML = html;
  
      // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }

    closeQuickView() {
      this.loadVersion = (this.loadVersion || 0) + 1;
      this.loadingPromise = null;
      const drawerContent = this.querySelector('.quick-view__content');
      if (drawerContent) {
        drawerContent.innerHTML = '';
        drawerContent.classList.remove('hide-cover');
      }
      this.closest('body')?.classList.remove('hidden', 'quick-view-open', 'quick-view-load')
      document.dispatchEvent(new CustomEvent('body:visible'));
      if(!this.closest('.image-with-hotspots')) {
        const cardContainer = this.closest('.card-container');
        const cardExtras = cardContainer?.querySelector('.card__extras');
        const quickButton = cardContainer?.querySelector('.quick');
        if (cardExtras) cardExtras.style.bottom = '-54px'
        quickButton?.classList.remove('active')
      }
      document.dispatchEvent(new CustomEvent('quickview:close'));
      this.closest('details')?.removeAttribute('open')
      removeTrapFocus(this.opener);
    }
  }
  if (!customElements.get('quick-view')) customElements.define('quick-view', QuickView);
